import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { BulkJobStep, useCurrentModalContext } from '../../providers/ModalProvider';

export const SuccessStep = () => {
  const { onSuccess, step } = useCurrentModalContext();

  if (step !== BulkJobStep.JobsSubmittedSuccessfully) {
    return null;
  }

  return (
    <div className="step-wrapper">
      <div>Jobs submitted successfully</div>
      <div className="buttonContainer">
        <OutlinedButton onClick={onSuccess}>Cancel</OutlinedButton>
        <Button className="ml-4" onClick={onSuccess}>
          Close
        </Button>
      </div>
    </div>
  );
};
